export default __webpack_public_path__ + "static/media/rappel.4ba66ab7.png";